// extracted by mini-css-extract-plugin
module.exports = {"page":"page__o-8iF"};